import * as analyticsService from "@store/Framework/Services/AnalyticsService";
import React, { useEffect, useRef } from "react";

export const usePrevious = (value: any) => {
    const ref = useRef<any>(null);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export const useAnalytics = () => {
    return analyticsService;
};
